type Ratings = 'Excellent' | 'Very Good' | 'Good' | 'Review Score';

const calculateRating = (rating: number) => {
  const ratingValue = rating * 2;

  return ratingValue === 10 ? ratingValue : ratingValue.toFixed(1);
};

const getRatingTag = (rating: number): Ratings => {
  const ratingValue = rating * 2;

  // immediate if is faster than a switch.
  if (ratingValue >= 9) {
    return 'Excellent';
  }

  if (ratingValue >= 8) {
    return 'Very Good';
  }

  if (ratingValue >= 7) {
    return 'Good';
  }

  return 'Review Score';
};

export { calculateRating, getRatingTag };
